export default __webpack_public_path__ + "static/media/heartbeat-white.a2efac76.svg";